import React from "react";
import { FaWhatsapp } from "react-icons/fa"; // أيقونة واتساب
import "./WhatsAppButton.css";

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/966509565618" // <-- عدّل الرقم بتاعك هنا (كود الدولة + الرقم)
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp className="whatsapp-icon" />
    </a>
  );
};

export default WhatsAppButton;
